/* eslint-disable react/prop-types */
import { DateTime } from 'luxon';
import React from 'react';
import Session from './Session.js';
import { HomePageURL } from '../components/PageElements.js';
import Redirect from './Redirect.js';

const GLOBAL_LINKS = Session.object('LINKS') || {};

export function formatPhone(str) {
    if (str.charAt(0) === '0') {
        return '234' + str.slice(1);
    } else if (str.charAt(0) === '+') {
        return str.slice(1);
    } else {
        return str;
    }
}

export function isValidHttpUrl(string) {
    try {
        const newUrl = new URL(string);
        return newUrl.protocol === 'http:' || newUrl.protocol === 'https:';
    } catch (err) {
        return false;
    }
}

export const youtube_parser = (url) => {
    var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
    var match = url.match(regExp);
    return (match && match[7].length == 11) ? match[7] : false;
};

export const GetAge = (dob) => {
    const date2 = DateTime.fromSQL(dob);
    const diff = DateTime.now().diff(date2, ['years', 'months', 'days']).toObject();
    let age = '';
    const yearName = diff.years == 1 ? 'yr' : 'yrs';
    const monthName = diff.months == 1 ? 'mth' : 'mths';
    const dayName = diff.days == 1 ? 'day' : 'days';
    diff.years && (age = age + `${diff.years}${yearName} `);
    diff.months && (age = age + `${diff.months}${monthName} old`);
    if (!age) age = `${Math.floor(diff.days)}${dayName} old`;
    return age;
};


function containsHTML(str) {
    // Regular expression to match HTML tags
    var htmlPattern = /<[^>]*>/;

    return htmlPattern.test(str);
}
export const NewlineText = (props) => {
    let text = props.children;
    if (!text || text.length < 2) return text;

    try {
        text = containsHTML(text) ? text : text?.split('\n').join('<br />');
    } catch (e) { /* empty */ }
    return <div className='text-break'
        dangerouslySetInnerHTML={{ __html: text }}
    />;
};

export const formatFloat = (n) => {
    if (isNaN(n)) return '0.00';
    return parseFloat(n).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
};

export const nth = (n) => {
    const r = ['st', 'nd', 'rd'][((n + 90) % 100 - 10) % 10 - 1] || 'th';
    return `${n}${r}`;
};

export const toTen = (n) => {
    return n < 10 ? '0' + n : n;
};

export const toTitleCase = str => str.replace(/\w\S*/g, txt => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase());

export const arrayLength = (n) => {
    let array = [];
    let j = 1;
    while (j <= n) {
        array.push(j);
        j++;
    }
    return array;
};

export const getImage = (filename) => {
    if (!filename || filename === 'undefined' || filename === 'null') return '';
    const links = Session.object('LINKS') || GLOBAL_LINKS;
    if (filename.startsWith('http') || filename.startsWith('data:')) return filename;
    return (links.cdn || 'https://cdn.mysyllabux.com/') + filename;
};


export const openInBrowser = (path) => {

    try {
        // eslint-disable-next-line no-undef
        if (lekeOjikutu && lekeOjikutu.openInBrowser) {
            // eslint-disable-next-line no-undef
            lekeOjikutu.openInBrowser(path);
        } else {
            // eslint-disable-next-line no-undef
            Website2APK.openExternal(path);
        }
    } catch (e) {

        window.open(path, '_blank');
    }
};

// eslint-disable-next-line no-unused-vars
export const APIResponse = (error, log = false) => {

    // eslint-disable-next-line no-undef
    if (process.env.REACT_APP_DEBUG == true || process.env.REACT_APP_DEBUG == 'true') {
        console.log(JSON.stringify(error, null, 2));
    }
    if (error.message?.startsWith('Failed to fetch')) {
        Session.alert('Check your internet connection.');
    } else if (!error.graphQLErrors || error.graphQLErrors[0]?.extensions?.code != 'INTERNAL_SERVER_ERROR') {
        if (error.message == '#RELOGIN') {
            const home = HomePageURL();
            Session.clear();
            Session.setSecureValue('x-access-token', '');
            Session.setSecureValue('x-refresh-token', '');
            Session.setCookie('x-access-token', '');
            Session.setCookie('x-refresh-token', '');

            window.redirect(home);
            Session.alert(error.message);
        } else if (error.message == '#NOACCESS') {
            Redirect('/school')
        } else {
            Session.alert(error.message);
        }
    } else {
        logError(error);
    }
};


export const readBase64 = (file) => {
    return new Promise((resolve) => {
        const reader = new FileReader();
        reader.onloadend = () => {
            const base64data = reader.result;
            resolve(base64data);
        };
        reader.readAsDataURL(file);
    });
};

export const readAsText = (file) => {
    return new Promise((resolve) => {
        const reader = new FileReader();
        reader.readAsText(file);
        reader.onload = () => {
            const readData = reader.result;
            resolve(readData);
        };
    });
};


export const resizeImage = (file) => {
    const max = 2048;//max Width Or Height in px
    // eslint-disable-next-line no-undef
    const maxSizeInKb = +process.env.REACT_APP_MAX_IMAGE_KB;
    // Create a promise
    return new Promise((resolve, reject) => {
        // Create a new image object
        let img = new Image();
        // Make sure the image file is valid
        if (!file || !file.type.match(/image.*/)) reject('Not an image file!');
        // Load the image object
        img.src = URL.createObjectURL(file);
        // When the image is loaded, resize it
        img.onload = () => {
            // Get the original width and height of the image
            let width = img.naturalWidth;
            let height = img.naturalHeight;
            // Calculate the new width and height of the image

            if (width > height) {
                if (width > max) {
                    height *= max / width;
                    width = max;
                }
            } else {
                if (height > max) {
                    width *= max / height;
                    height = max;
                }
            }
            // Create a canvas to draw the resized image
            let canvas = document.createElement('canvas');
            canvas.width = width;
            canvas.height = height;
            let ctx = canvas.getContext('2d');
            ctx.drawImage(img, 0, 0, width, height);
            // Convert the canvas image to a data URL
            let dataUrl = canvas.toDataURL('image/png');
            // Convert the data URL to a Blob
            let blob = dataURLtoBlob(dataUrl);
            // Calculate the file size of the Blob
            let fileSize = Math.round(blob.size / 1024);
            // If the file size is bigger than 120kb, resize it further
            while (fileSize > maxSizeInKb + 20) {
                const reduction = 0.8;
                // Create a new canvas to draw the resized image
                let newCanvas = document.createElement('canvas');
                width = width * reduction;
                height = height * reduction;
                newCanvas.width = width;
                newCanvas.height = height;
                let newCtx = newCanvas.getContext('2d');
                newCtx.drawImage(img, 0, 0, width, height);
                // Convert the new canvas image to a data URL
                dataUrl = newCanvas.toDataURL('image/png');

                blob = dataURLtoBlob(dataUrl);
                // Calculate the file size of the Blob
                fileSize = Math.round(blob.size / 1024);
            }
            // Resolve the promise with the original image data URL
            resolve(dataUrl);


        };
    });
};


// Helper function to convert a data URL to a Blob
const dataURLtoBlob = (dataURL) => {
    let byteString;
    if (dataURL.split(',')[0].indexOf('base64') >= 0)
        byteString = atob(dataURL.split(',')[1]);
    else byteString = unescape(dataURL.split(',')[1]);
    let mimeString = dataURL
        .split(',')[0]
        .split(':')[1]
        .split(';')[0];
    let ia = new Uint8Array(byteString.length);
    for (let i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
    }
    return new Blob([ia], { type: mimeString });
};



export const csvToArray = (csv) => {
    const lines = csv.trim()
        .split(',,').join(',--,')
        .split(',,').join(',--,')
        .split(',,').join(',--,')
        .split(',,').join(',--,')
        .split(',,').join(',--,')
        .split(',,').join(',--,')
        .split(',,').join(',--,')
        .split(`
`);
    const result = [];

    for (let i = 0; i < lines.length; i++) {
        const fields = lines[i].match(/(".*?"|[^",]+)(?=,|$)/g).map((field) => field.trim().replace(/^"|"$/g, ''));
        result.push(fields);
    }

    return result;
};

/**
 * Strips V4 template engine UI elements from HTML for V3 display
 * Removes: garbage class buttons, drop-element wrappers, onclick handlers, data attributes
 */
export const stripV4EditorElements = (html) => {
    if (!html || typeof html !== 'string') return html;

    let stripped = html;

    // Remove elements with 'garbage' class (delete buttons) - buttons and spans
    stripped = stripped.replace(/<button[^>]*class="[^"]*garbage[^"]*"[^>]*>[\s\S]*?<\/button>/gi, '');
    stripped = stripped.replace(/<span[^>]*class="[^"]*garbage[^"]*"[^>]*>[\s\S]*?<\/span>/gi, '');

    // Remove drop-element class wrappers (keep inner content)
    // Match opening div with drop-element class and remove the class attribute
    stripped = stripped.replace(/class="[^"]*drop-element[^"]*"/gi, '');

    // Remove data-tpl and data-title attributes
    stripped = stripped.replace(/\s*data-tpl="[^"]*"/gi, '');
    stripped = stripped.replace(/\s*data-title="[^"]*"/gi, '');

    // Remove onclick handlers that call remove() or parentElement.remove()
    stripped = stripped.replace(/onclick="[^"]*parentElement\.remove\(\)[^"]*"/gi, '');
    stripped = stripped.replace(/onclick="[^"]*\.remove\(\)[^"]*"/gi, '');
    stripped = stripped.replace(/onclick="[^"]*updateStorage\(\)[^"]*"/gi, '');
    stripped = stripped.replace(/onclick="[^"]*previewImage\([^)]*\)[^"]*"/gi, '');

    // Remove w3-display-container and w3-display-topright/right classes from divs
    stripped = stripped.replace(/class="w3-display-container"/gi, 'class=""');
    stripped = stripped.replace(/class="w3-display-topright"/gi, 'class=""');
    stripped = stripped.replace(/class="w3-display-right"/gi, 'class=""');

    // Remove input type="file" with garbage class (image upload buttons in editor)
    stripped = stripped.replace(/<input[^>]*class="[^"]*garbage[^"]*"[^>]*type="file"[^>]*>/gi, '');

    // Process [*] placeholders: replace with a static checked checkbox indicator
    // V4 template engine replaces [*] with interactive checkboxes; for V3 display we use static checkmarks
    stripped = stripped.split('[*]').map((part, idx) => {
        if (idx === 0) return part;
        // Insert a static checkmark indicator before the rest of the content
        return `<span class="skill-checked">&#10003;</span>${part}`;
    }).join('');

    // Clean up empty class attributes
    stripped = stripped.replace(/class=""/gi, '');

    // Clean up multiple spaces
    stripped = stripped.replace(/\s+/gi, ' ');

    return stripped;
};

const logError = async (error) => {
    var data = new FormData();
    data.append('error', JSON.stringify(error, null, 0));
    // eslint-disable-next-line no-undef
    data.append('app', process.env.REACT_APP_APP);

    // eslint-disable-next-line no-undef
    fetch(process.env.REACT_APP_ERROR_URL, {
        method: 'POST',
        body: data
        // eslint-disable-next-line no-unused-vars
    }).catch(error => {
        // Catch errors
    });
};


export const getBrand = () => {
    let brandHasBeenChecked = Session.secureValue('BrandHasBeenChecked');
    if (!brandHasBeenChecked || brandHasBeenChecked.length < 2) {
        brandHasBeenChecked = Session.value('BrandHasBeenChecked');
    }
    // if (brandHasBeenChecked.length < 2) {
    //     // eslint-disable-next-line no-undef
    //     if (process.env.REACT_APP_DEBUG != true && process.env.REACT_APP_DEBUG != 'true') {
    //         window.location = 'https://mysyllabux.com/brandError.html';
    //     }
    // } else {
    try {
        const brand = JSON.parse(brandHasBeenChecked);
        return brand;
    } catch (e) {/*empty*/ }
    // }

    return {
        schoolID: 0,
        schoolName: '',
        slogan: ''
    };
};

export const goToWelcomePage = () => {
    window.location = 'https://mysyllabux.com/brand.php';
};


export const downloadData = (content, mimeType, filename) => {
    return new Promise((resolve, reject) => {
        try {
            // Convert content to Blob if it's not already one
            const blob = content instanceof Blob
                ? content
                : new Blob([content], { type: mimeType });

            // Handle iOS Safari specifically (which has limitations with downloads)
            if (navigator.userAgent.match(/(iPad|iPhone|iPod)/g)) {
                // For iOS devices, we'll use a different approach
                const reader = new FileReader();
                reader.onloadend = function () {
                    const url = reader.result;

                    // Create temporary iframe to handle download
                    const iframe = document.createElement('iframe');
                    iframe.style.display = 'none';
                    document.body.appendChild(iframe);

                    // Either write to iframe, or open in new window
                    try {
                        iframe.contentWindow.document.write(`
                <a id="downloadLink" href="${url}" download="${filename}">Download</a>
              `);
                        iframe.contentWindow.document.getElementById('downloadLink').click();
                        setTimeout(() => {
                            document.body.removeChild(iframe);
                            resolve(true);
                        }, 100);
                    } catch (e) {
                        // Fallback for some mobile browsers - open in new tab
                        window.open(url, '_blank');
                        resolve(true);
                    }
                };
                reader.onerror = () => reject(new Error('FileReader error'));
                reader.readAsDataURL(blob);
                return;
            }

            // Standard approach for most browsers
            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');

            // Set download attributes
            a.href = url;
            a.download = filename;
            a.style.display = 'none';

            // Add to DOM, trigger click, then remove
            document.body.appendChild(a);
            a.click();

            // Clean up
            setTimeout(() => {
                document.body.removeChild(a);
                URL.revokeObjectURL(url); // Important: release the object URL to free memory
                resolve(true);
            }, 100);
        } catch (error) {
            reject(error);
        }
    });
};

export const GetFileType = (filename) => {
    if (!filename) return 'DOCUMENT';
    const types = {
        "jpeg": "IMAGE",
        "jpg": "IMAGE",
        "png": "IMAGE",
        "webp": "IMAGE",
        "gif": "IMAGE",
        "bmp": "IMAGE",
        "svg": "IMAGE",
        "mp3": "AUDIO",
        "wav": "AUDIO",
        "ogg": "AUDIO",
        "aac": "AUDIO",
        "amr": "AUDIO",
        "m4a": "AUDIO",
        "mpeg": "AUDIO",
        "webm": "VIDEO",
        "mp4": "VIDEO",
        "ogv": "VIDEO",
        "mkv": "VIDEO",
        "pdf": "DOCUMENT"
    };
    const parts = filename.split('.');
    const ext = parts[parts.length - 1] || '';
    return types[ext] ?? 'DOCUMENT';
}


export const tryParse = (jsonString, defaultValue) => {
    // Handle null, undefined, or empty values
    if (jsonString === null || jsonString === undefined) return defaultValue;

    // Already parsed object/array - check for null explicitly
    if (typeof jsonString === "object" && jsonString !== null) return jsonString;

    // Must be a string at this point
    if (typeof jsonString !== "string") return defaultValue;

    // Additional safety check for string methods
    if (typeof jsonString.trim !== 'function') return defaultValue;

    const trimmedString = jsonString.trim();
    if (trimmedString === "") return defaultValue;

    try {
        let parsedResult = JSON.parse(jsonString);

        // Handle double-encoded JSON
        if (typeof parsedResult === "string") {
            try {
                parsedResult = JSON.parse(parsedResult);
            } catch {
                // second parse failed → leave it as string
            }
        }

        if (parsedResult !== null && typeof parsedResult === "object") {
            return parsedResult;
        }

        return defaultValue;
    } catch {
        return defaultValue;
    }
};
